// src/components/AmenityGallery/AmenityGallery.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import './AmenityGallery.css';

const AmenityGallery = ({ images, title }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);

  const MAX_THUMBNAILS = 3;
  const hasMoreImages = images && images.length > MAX_THUMBNAILS;
  const remainingImagesCount = hasMoreImages ? images.length - MAX_THUMBNAILS : 0;
  const visibleThumbnails = images ? images.slice(0, MAX_THUMBNAILS) : [];

  const openLightbox = useCallback((index = 0) => {
    setCurrentIndex(index); // CORRIGIDO
    setIsLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  }, []);

  const closeLightbox = useCallback(() => {
    setIsLightboxOpen(false);
    document.body.style.overflow = 'auto';
  }, []);

  const goToNext = useCallback(() => {
    if (!images) return;
    setCurrentIndex(prev => (prev === images.length - 1 ? 0 : prev + 1)); // CORRIGIDO
  }, [images]);

  const goToPrev = useCallback(() => {
    if (!images) return;
    setCurrentIndex(prev => (prev === 0 ? images.length - 1 : prev - 1)); // CORRIGIDO
  }, [images]);

  const selectImage = (index) => {
    setCurrentIndex(index); // CORRIGIDO
  };
  
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (isLightboxOpen) {
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowRight') goToNext();
        if (e.key === 'ArrowLeft') goToPrev();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isLightboxOpen, closeLightbox, goToNext, goToPrev]);

  if (!Array.isArray(images) || images.length === 0) {
    return <div className="amenity-gallery-placeholder"><span>Sem imagens disponíveis</span></div>;
  }

  return (
    <>
      <div className="amenity-gallery">
        <div className="main-image-container">
          <img key={images[currentIndex]} src={images[currentIndex]} alt={`${title} - Foto ${currentIndex + 1}`} className="main-image" onClick={() => openLightbox(currentIndex)} />
          
          {images.length > 1 && (
            <>
              <button onClick={(e) => { e.stopPropagation(); goToPrev(); }} className="gallery-nav-btn prev"><FaChevronLeft /></button>
              <button onClick={(e) => { e.stopPropagation(); goToNext(); }} className="gallery-nav-btn next"><FaChevronRight /></button>
            </>
          )}
        </div>

        {images.length > 1 && (
          <div className="thumbnail-strip">
            {visibleThumbnails.map((image, index) => {
              const isLastVisible = index === MAX_THUMBNAILS - 1;
              const shouldShowMoreIndicator = isLastVisible && hasMoreImages;

              return (
                <div 
                  key={index}
                  className={`thumbnail-item ${index === currentIndex ? 'active' : ''}`}
                  onClick={shouldShowMoreIndicator ? () => openLightbox(index) : () => selectImage(index)}
                >
                  <img src={image} alt={`Miniatura ${index + 1}`} />
                  {shouldShowMoreIndicator && (
                    <div className="thumbnail-more-overlay">
                      <span>+{remainingImagesCount}</span>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {isLightboxOpen && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}><FaTimes /></button>
            <button className="lightbox-nav lightbox-prev" onClick={goToPrev}><FaChevronLeft /></button>
            <div className="lightbox-image-container">
              <img 
                src={images[currentIndex]} 
                alt={`Imagem ${currentIndex + 1}`} 
                className="lightbox-image"
              />
              <div className="lightbox-counter">{currentIndex + 1} / {images.length}</div>
            </div>
            <button className="lightbox-nav lightbox-next" onClick={goToNext}><FaChevronRight /></button>
          </div>
        </div>
      )}
    </>
  );
};

export default AmenityGallery;